// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* product grid start*/
/* responsive width for product */
/* product grid end*/
/* ✅ FIX 1: Update product-width for larger cards */
.product-width {
  width: 31%; /* Changed from 32% - gives better spacing */
}
@media (max-width: 1200px) {
  .product-width {
    width: 48%;
  }
}
@media (max-width: 768px) {
  .product-width {
    width: 100%;
  }
}

/* ✅ FIX 2: Fix hover overlay - add these missing styles */
.product-grid {
  background-color: #fff;
  position: relative;
  margin-bottom: 30px;
  transition: all 0.5s ease-in-out;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
}
.product-grid .product_img {
  position: relative;
  overflow: hidden;
  height: 400px; /* ✅ ADDED - Fixed image container height */
  /* ✅ FIX 3: Fixed hover selector */
  /* ✅ FIX 4: Fixed hover selector */
}
.product-grid .product_img img {
  transition: all 0.3s ease-in-out;
  width: 100%; /* ✅ ADDED */
  height: 100%; /* ✅ ADDED */
  object-fit: cover; /* ✅ ADDED - Proper image scaling */
}
.product:hover .product-grid .product_img img {
  transform: scale(1.1);
}
.product-grid .product_img::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: all 0.5s ease-in-out;
  z-index: 1;
}
.product-grid .product_img:hover::before {
  opacity: 1;
}
.product-grid .product_img .product_action_box {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 2;
  right: 0;
  text-align: center;
  padding-top: 0;
  transition: all 0.5s ease-in-out;
  transform: translateY(-50%);
  opacity: 0;
}
.product-grid .product_img:hover .product_action_box {
  opacity: 1;
}
.product-grid .product_img .pr_action_btn li {
  position: relative;
  margin: 0 5px;
  display: inline-block;
}
.product-grid .product_img .pr_action_btn li p {
  background-color: #fff;
  font-size: 0;
  text-transform: capitalize;
  transition: all 0.3s ease-in-out;
  width: 37px;
  height: 37px;
  text-align: center;
  cursor: pointer;
  position: relative;
  z-index: 1;
  border-radius: 50%; /* ✅ ADDED - Makes buttons circular */
  display: flex; /* ✅ ADDED */
  align-items: center; /* ✅ ADDED */
  justify-content: center; /* ✅ ADDED */
}
.product-grid .product_img .pr_action_btn li p:hover {
  background-color: #ff324d;
  color: #fff;
}
.product-grid .product_img .pr_action_btn li p i {
  vertical-align: middle;
  line-height: 37px;
  font-size: 18px;
}

.grid-layout {
  border: 1px solid;
  border-radius: 4px;
  padding: 4px 8px;
}

.active-grid-layout {
  border: 1px solid #ff324d;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: #ff324d;
  color: #fff;
}

/* product row start */
.product-row {
  background-color: #fff;
  position: relative;
  margin-bottom: 30px;
  transition: all 0.5s ease-in-out;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
}
.product-row .product_img {
  width: 24%;
  height: 24%;
}
@media (max-width: 992px) {
  .product-row .product_img {
    width: 100%;
  }
}
.product-row .product_title span {
  font-size: 24px;
  cursor: pointer;
}
.product-row .product_title span:hover {
  color: #ff324d;
}
.product-row .list_product_action_box ul li {
  font-size: 18px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.product-row .list_product_action_box ul li p {
  margin: 0px;
  cursor: pointer;
}
.product-row .pr_desc p {
  font-size: 18px;
}

/* common   */
.product_color_switch {
  display: flex;
  align-items: center;
  gap: 5px;
}
.product_color_switch span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  border: 1px solid #ddd;
}

.product_title {
  padding-top: 10px;
}
.product_title span {
  font-size: 24px;
  cursor: pointer;
}
.product_title span:hover {
  color: #ff324d;
}

.product_price {
  display: flex;
  align-items: center;
  gap: 10px;
}
.product_price .price {
  font-size: 24px;
  color: #ff324d;
  font-weight: 600;
}
.product_price del {
  color: gray;
  font-size: 18px;
}
.product_price .on_sale span {
  color: gray;
  font-size: 18px;
}

/* popmodule */
.pop-module .product-title p {
  font-size: 24px;
  margin: 0px;
  font-weight: 600;
  color: #000;
}
.pop-module .product-details span {
  font-size: 18px;
  margin: 0;
  color: #000;
}
.pop-module .product-details .price {
  display: block;
  color: #ff324d;
  font-size: 28px;
  font-weight: 600;
}

/* strar component */
.star {
  color: gray;
  transition: color 0.2s ease;
}

.star.filled {
  color: gold;
}

/* Rotating icon when the dropdown is open */
.category .still {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);
}
.category .rotate {
  transition: transform 0.3s ease-in-out;
  transform: rotate(90deg);
}
.category .subcategory {
  cursor: pointer;
}
.category .subcategory:hover {
  color: #ff324d;
}

.brnad input {
  margin: 10px;
}

.size ul {
  display: flex;
  gap: 5px;
}
.size ul li {
  border: 1px solid #000;
  padding: 5px;
  cursor: pointer;
}

/* Floating Cart Button */
.cart-fab {
  position: fixed;
  top: 90px; /* below Go Back Login */
  right: 30px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #1e40af);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.35);
  cursor: pointer;
  z-index: 1050;
  transition: all 0.25s ease;
}

.cart-fab:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.45);
}

/* Cart Count Badge */
.cart-fab-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #22c55e; /* green badge */
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 7px;
  border-radius: 999px;
  min-width: 20px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

/* ===== Material Catalog ONLY ===== */
.material-catalog-page {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.material-catalog-page .subContent {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.material-catalog-page .rightSide {
  padding-left: 0 !important;
}

.material-catalog-page .rightSideInner {
  padding-left: 12px; /* keep small spacing */
}

.material-catalog-page .catalog-sidebar {
  position: sticky;
  top: 90px; /* below header + Go Back Login */
  align-self: flex-start;
  height: calc(100vh - 110px);
  overflow-y: auto;
  padding-right: 10px;
}

/* Optional: smooth scrollbar */
.material-catalog-page .catalog-sidebar::-webkit-scrollbar {
  width: 6px;
}

.material-catalog-page .catalog-sidebar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

/* ===== Sticky Header : Material Catalog ONLY ===== */
.material-catalog-page .catalog-sticky-header {
  position: sticky;
  top: 0;
  z-index: 1040;
  background: #F0F5FA;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #F0F5FA;
}

/* Header right actions */
.catalog-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Inline cart (header version) */
.cart-fab-inline {
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #2563eb);
  color: #F0F5FA;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.cart-fab-inline:hover {
  transform: scale(1.05);
}

.po-image-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.po-product-img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.free-delivery-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #00c853, #00e676);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 20px;
  z-index: 10;
  animation: glowGreen 1.6s infinite ease-in-out;
}

.free-delivery-badge i {
  font-size: 14px;
}

/* 🌟 Neon green glow */
@keyframes glowGreen {
  0% {
    box-shadow: 0 0 6px rgba(0, 200, 83, 0.6);
  }
  50% {
    box-shadow: 0 0 16px 6px rgba(0, 230, 118, 0.9);
  }
  100% {
    box-shadow: 0 0 6px rgba(0, 200, 83, 0.6);
  }
}
.catalog-sticky-header {
  position: sticky;
  top: 60px;
  z-index: 999;
  background: #F0F5FA;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px;
  margin: 0 -10px 20px -12px;
}
.catalog-sticky-header .catalog-header-left .mainTitle {
  margin-bottom: 4px;
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
}
.catalog-sticky-header .catalog-header-left .subText {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}
.catalog-sticky-header .catalog-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cart-fab-inline {
  position: relative;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #1e40af);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
  transition: all 0.25s ease;
  z-index: 1; /* ✅ Added - keeps button visible */
}
.cart-fab-inline:hover {
  transform: translateY(-3px) scale(1.08);
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.5);
}
.cart-fab-inline:active {
  transform: translateY(-1px) scale(1.02);
}

/* Cart Badge */
.cart-fab-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #22c55e;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 7px;
  border-radius: 999px;
  min-width: 22px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
  border: 2px solid #F0F5FA;
  z-index: 2; /* ✅ Added - keeps badge on top */
}

/* Responsive */
@media (max-width: 768px) {
  .catalog-sticky-header {
    padding: 12px 16px;
    top: 60px; /* ✅ Keep consistent on mobile */
  }
  .catalog-sticky-header .catalog-header-left .mainTitle {
    font-size: 22px;
  }
  .catalog-sticky-header .cart-fab-inline {
    width: 46px;
    height: 46px;
  }
}
@media (max-width: 576px) {
  .catalog-sticky-header .catalog-header-left .mainTitle {
    font-size: 20px;
  }
  .catalog-sticky-header .catalog-header-left .subText {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/supplier_app/MaterialCatalogShopwies/Materialcatalog.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sBAAA;AA4EA,iCAAA;AAUA,oBAAA;AAEA,mDAAA;AACA;EACE,UAAA,EAAA,4CAAA;AAnFF;AAoFE;EAFF;IAGI,UAAA;EAjFF;AACF;AAkFE;EALF;IAMI,WAAA;EA/EF;AACF;;AAkFA,0DAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sCAAA;AA/EF;AAiFE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA,EAAA,2CAAA;EA0BA,kCAAA;EAkBA,kCAAA;AAzHJ;AA+EI;EACE,gCAAA;EACA,WAAA,EAAA,YAAA;EACA,YAAA,EAAA,YAAA;EACA,iBAAA,EAAA,mCAAA;AA7EN;AA+EM;EACE,qBAAA;AA7ER;AAiFI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,oCAAA;EACA,UAAA;EACA,gCAAA;EACA,UAAA;AA/EN;AAmFI;EACE,UAAA;AAjFN;AAoFI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,2BAAA;EACA,UAAA;AAlFN;AAsFI;EACE,UAAA;AApFN;AAwFM;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;AAtFR;AAuFQ;EACE,sBAAA;EACA,YAAA;EACA,0BAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA,EAAA,qCAAA;EACA,aAAA,EAAA,YAAA;EACA,mBAAA,EAAA,YAAA;EACA,uBAAA,EAAA,YAAA;AArFV;AAuFU;EACE,yBAAA;EACA,WAAA;AArFZ;AAuFU;EACE,sBAAA;EACA,iBAAA;EACA,eAAA;AArFZ;;AA+FA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AA5FF;;AA8FA;EACC,yBAAA;EACG,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AA3FJ;;AA8FA,sBAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sCAAA;AA3FF;AA4FE;EACE,UAAA;EACA,WAAA;AA1FJ;AA2FI;EAHF;IAII,WAAA;EAxFJ;AACF;AA2FI;EACE,eAAA;EACA,eAAA;AAzFN;AA0FM;EACE,cAAA;AAxFR;AA8FM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA5FR;AA8FQ;EACE,WAAA;EACA,eAAA;AA5FV;AAkGI;EACE,eAAA;AAhGN;;AAoGA,aAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjGF;AAkGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AAhGJ;;AAmGA;EACE,iBAAA;AAhGF;AAiGE;EACE,eAAA;EACA,eAAA;AA/FJ;AAgGI;EACE,cAAA;AA9FN;;AAkGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA/FF;AAiGE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA/FJ;AAiGE;EACE,WAAA;EACA,eAAA;AA/FJ;AAkGI;EACE,WAAA;EACA,eAAA;AAhGN;;AAqGA,cAAA;AAGI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AApGN;AAwGI;EACE,eAAA;EACA,SAAA;EACA,WAAA;AAtGN;AAwGI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAtGN;;AA0GA,oBAAA;AACA;EACE,WAAA;EACA,2BAAA;AAvGF;;AA0GA;EACE,WAAA;AAvGF;;AA0GA,4CAAA;AAEE;EACE,eAAA;EACA,sCAAA;EACA,uBAAA;AAxGJ;AA0GE;EACE,sCAAA;EACA,wBAAA;AAxGJ;AA0GE;EACE,eAAA;AAxGJ;AAyGI;EACE,cAAA;AAvGN;;AA4GE;EACE,YAAA;AAzGJ;;AA6GE;EACE,aAAA;EACA,QAAA;AA1GJ;AA2GI;EACE,sBAAA;EACA,YAAA;EACA,eAAA;AAzGN;;AA+GA,yBAAA;AACA;EACE,eAAA;EACA,SAAA,EAAA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;AA5GF;;AA+GA;EACE,uCAAA;EACA,+CAAA;AA5GF;;AA+GA,qBAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA,EAAA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;AA5GF;;AA+GA,sCAAA;AACA;EACE,0BAAA;EACA,yBAAA;AA5GF;;AA+GA;EACE,yBAAA;EACA,0BAAA;AA5GF;;AA+GA;EACE,0BAAA;AA5GF;;AA+GA;EACE,kBAAA,EAAA,uBAAA;AA5GF;;AAgHA;EACE,gBAAA;EACA,SAAA,EAAA,iCAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AA7GF;;AAgHA,+BAAA;AACA;EACE,UAAA;AA7GF;;AAgHA;EACE,mBAAA;EACA,kBAAA;AA7GF;;AAgHA,sDAAA;AAEA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AA9GF;;AAiHA,yBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9GF;;AAiHA,iCAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA9GF;;AAiHA;EACE,sBAAA;AA9GF;;AAiHA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA9GF;;AAiHA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AA9GF;;AAmHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,iBAAA;EACA,qDAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;EAEA,mBAAA;EACA,WAAA;EAEA,8CAAA;AArHF;;AAwHA;EACE,eAAA;AArHF;;AAwHA,uBAAA;AACA;EACE;IACE,yCAAA;EArHF;EAuHA;IACE,+CAAA;EArHF;EAuHA;IACE,yCAAA;EArHF;AACF;AAyHA;EACE,gBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,0BAAA;AAvHF;AA4HI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA1HN;AA6HI;EACE,eAAA;EACA,cAAA;EACA,SAAA;AA3HN;AA+HE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7HJ;;AAkIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,8CAAA;EACA,0BAAA;EACA,UAAA,EAAA,mCAAA;AA/HF;AAiIE;EACE,uCAAA;EACA,8CAAA;AA/HJ;AAkIE;EACE,uCAAA;AAhIJ;;AAoIA,eAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA,EAAA,iCAAA;AAjIF;;AAoIA,eAAA;AACA;EACE;IACE,kBAAA;IACA,SAAA,EAAA,gCAAA;EAjIF;EAoII;IACE,eAAA;EAlIN;EAsIE;IACE,WAAA;IACA,YAAA;EApIJ;AACF;AAwIA;EAGM;IACE,eAAA;EAxIN;EA2II;IACE,eAAA;EAzIN;AACF","sourcesContent":["/* product grid start*/\n// .product-grid {\n//   background-color: #fff;\n//   position: relative;\n//   margin-bottom: 30px;\n//   transition: all 0.5s ease-in-out;\n//   box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n//   .product_img {\n//     position: relative;\n//     overflow: hidden;\n//     img {\n//       transition: all 0.3s ease-in-out;\n//       .product:hover & {\n//         transform: scale(1.1);\n//       }\n//     }\n//     &::before {\n//       content: \"\";\n//       position: absolute;\n//       left: 0;\n//       right: 0;\n//       bottom: 0;\n//       top: 0;\n//       background-color: rgba(0, 0, 0, 0.2);\n//       opacity: 0;\n//       transition: all 0.5s ease-in-out;\n//       z-index: 1;\n//     }\n//     :hover > &::before {\n//       opacity: 1;\n//     }\n//     .product_action_box {\n//       position: absolute;\n//       top: 50%;\n//       left: 0;\n//       z-index: 2;\n//       right: 0;\n//       text-align: center;\n//       padding-top: 0;\n//       transition: all 0.5s ease-in-out;\n//       transform: translateY(-50%);\n//       opacity: 0; // Initially hidden\n//       :hover > & {\n//         opacity: 1;\n//       }\n//     }\n//     .pr_action_btn {\n//       li {\n//         position: relative;\n//         margin: 0 5px;\n//         display: inline-block;\n//         p {\n//           background-color: #fff;\n//           font-size: 0;\n//           text-transform: capitalize;\n//           transition: all 0.3s ease-in-out;\n//           width: 37px;\n//           height: 37px;\n//           text-align: center;\n//           cursor: pointer;\n//           position: relative;\n//           z-index: 1;\n//           &:hover {\n//             background-color: #ff324d;\n//             color: #fff;\n//           }\n//           i {\n//             vertical-align: middle;\n//             line-height: 37px;\n//             font-size: 18px;\n//           }\n//         }\n//       }\n//     }\n//   }\n// }\n/* responsive width for product */\n// .product-width {\n//   width: 32%;\n//   @media (max-width: 1200px) {\n//     width: 48%;\n//   }\n//   @media (max-width: 768px) {\n//     width: 100%;\n//   }\n// }\n/* product grid end*/\n\n/* ✅ FIX 1: Update product-width for larger cards */\n.product-width {\n  width: 31%; /* Changed from 32% - gives better spacing */\n  @media (max-width: 1200px) {\n    width: 48%;\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n}\n\n/* ✅ FIX 2: Fix hover overlay - add these missing styles */\n.product-grid {\n  background-color: #fff;\n  position: relative;\n  margin-bottom: 30px;\n  transition: all 0.5s ease-in-out;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n  \n  .product_img {\n    position: relative;\n    overflow: hidden;\n    height: 400px; /* ✅ ADDED - Fixed image container height */\n    \n    img {\n      transition: all 0.3s ease-in-out;\n      width: 100%; /* ✅ ADDED */\n      height: 100%; /* ✅ ADDED */\n      object-fit: cover; /* ✅ ADDED - Proper image scaling */\n      \n      .product:hover & {\n        transform: scale(1.1);\n      }\n    }\n    \n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      top: 0;\n      background-color: rgba(0, 0, 0, 0.2);\n      opacity: 0;\n      transition: all 0.5s ease-in-out;\n      z-index: 1;\n    }\n    \n    /* ✅ FIX 3: Fixed hover selector */\n    &:hover::before {\n      opacity: 1;\n    }\n    \n    .product_action_box {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      z-index: 2;\n      right: 0;\n      text-align: center;\n      padding-top: 0;\n      transition: all 0.5s ease-in-out;\n      transform: translateY(-50%);\n      opacity: 0;\n    }\n    \n    /* ✅ FIX 4: Fixed hover selector */\n    &:hover .product_action_box {\n      opacity: 1;\n    }\n    \n    .pr_action_btn {\n      li {\n        position: relative;\n        margin: 0 5px;\n        display: inline-block;\n        p {\n          background-color: #fff;\n          font-size: 0;\n          text-transform: capitalize;\n          transition: all 0.3s ease-in-out;\n          width: 37px;\n          height: 37px;\n          text-align: center;\n          cursor: pointer;\n          position: relative;\n          z-index: 1;\n          border-radius: 50%; /* ✅ ADDED - Makes buttons circular */\n          display: flex; /* ✅ ADDED */\n          align-items: center; /* ✅ ADDED */\n          justify-content: center; /* ✅ ADDED */\n          \n          &:hover {\n            background-color: #ff324d;\n            color: #fff;\n          }\n          i {\n            vertical-align: middle;\n            line-height: 37px;\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n\n.grid-layout {\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n.active-grid-layout {\n\tborder: 1px solid #ff324d;\n    border-radius: 4px;\n    padding: 4px 8px;\n    background-color: #ff324d;\n    color: #fff;\n}\n\n/* product row start */\n.product-row {\n  background-color: #fff;\n  position: relative;\n  margin-bottom: 30px;\n  transition: all 0.5s ease-in-out;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n  .product_img {\n    width: 24%; // Default for large screens\n    height: 24%;\n    @media (max-width: 992px) {\n      width: 100%; // Full width on small screens\n    }\n  }\n  .product_title {\n    span {\n      font-size: 24px;\n      cursor: pointer;\n      &:hover {\n        color: #ff324d;\n      }\n    }\n  }\n  .list_product_action_box {\n    ul {\n      li {\n        font-size: 18px;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n\n        p {\n          margin: 0px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .pr_desc {\n    p {\n      font-size: 18px;\n    }\n  }\n}\n/* common   */\n.product_color_switch {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  span {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    display: inline-block;\n    cursor: pointer;\n    border: 1px solid #ddd;\n  }\n}\n.product_title {\n  padding-top: 10px;\n  span {\n    font-size: 24px;\n    cursor: pointer;\n    &:hover {\n      color: #ff324d;\n    }\n  }\n}\n.product_price {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  // padding: 10px 0px;\n  .price {\n    font-size: 24px;\n    color: #ff324d;\n    font-weight: 600;\n  }\n  del {\n    color: gray;\n    font-size: 18px;\n  }\n  .on_sale {\n    span {\n      color: gray;\n      font-size: 18px;\n    }\n  }\n}\n\n/* popmodule */\n.pop-module {\n  .product-title {\n    p {\n      font-size: 24px;\n      margin: 0px;\n      font-weight: 600;\n      color: #000;\n    }\n  }\n  .product-details {\n    span {\n      font-size: 18px;\n      margin: 0;\n      color: #000;\n    }\n    .price {\n      display: block;\n      color: #ff324d;\n      font-size: 28px;\n      font-weight: 600;\n    }\n  }\n}\n/* strar component */\n.star {\n  color: gray;\n  transition: color 0.2s ease;\n}\n\n.star.filled {\n  color: gold;\n}\n\n/* Rotating icon when the dropdown is open */\n.category {\n  .still {\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n    transform: rotate(0deg);\n  }\n  .rotate {\n    transition: transform 0.3s ease-in-out;\n    transform: rotate(90deg);\n  }\n  .subcategory {\n    cursor: pointer;\n    &:hover {\n      color: #ff324d;\n    }\n  }\n}\n.brnad {\n  input {\n    margin: 10px;\n  }\n}\n.size {\n  ul {\n    display: flex;\n    gap: 5px;\n    li {\n      border: 1px solid #000;\n      padding: 5px;\n      cursor: pointer;\n    }\n  }\n}\n\n\n/* Floating Cart Button */\n.cart-fab {\n  position: fixed;\n  top: 90px;            /* below Go Back Login */\n  right: 30px;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #2563eb, #1e40af);\n  color: #fff;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.35);\n  cursor: pointer;\n  z-index: 1050;\n  transition: all 0.25s ease;\n}\n\n.cart-fab:hover {\n  transform: translateY(-2px) scale(1.05);\n  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.45);\n}\n\n/* Cart Count Badge */\n.cart-fab-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: #22c55e;       /* green badge */\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 7px;\n  border-radius: 999px;\n  min-width: 20px;\n  text-align: center;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.25);\n}\n\n/* ===== Material Catalog ONLY ===== */\n.material-catalog-page {\n  padding-left: 0 !important;\n  margin-left: 0 !important;\n}\n\n.material-catalog-page .subContent {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.material-catalog-page .rightSide {\n  padding-left: 0 !important;\n}\n\n.material-catalog-page .rightSideInner {\n  padding-left: 12px; /* keep small spacing */\n}\n\n\n.material-catalog-page .catalog-sidebar {\n  position: sticky;\n  top: 90px; /* below header + Go Back Login */\n  align-self: flex-start;\n  height: calc(100vh - 110px);\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n/* Optional: smooth scrollbar */\n.material-catalog-page .catalog-sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.material-catalog-page .catalog-sidebar::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n/* ===== Sticky Header : Material Catalog ONLY ===== */\n\n.material-catalog-page .catalog-sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 1040;\n  background: #F0F5FA;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-bottom: 1px solid #F0F5FA;\n}\n\n/* Header right actions */\n.catalog-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Inline cart (header version) */\n.cart-fab-inline {\n  position: relative;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #2563eb, #2563eb);\n  color: #F0F5FA;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.cart-fab-inline:hover {\n  transform: scale(1.05);\n}\n\n.po-image-list {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.po-product-img {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n\n\n.free-delivery-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #00c853, #00e676);\n  color: #ffffff;\n\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n\n  border-radius: 20px;\n  z-index: 10;\n\n  animation: glowGreen 1.6s infinite ease-in-out;\n}\n\n.free-delivery-badge i {\n  font-size: 14px;\n}\n\n/* 🌟 Neon green glow */\n@keyframes glowGreen {\n  0% {\n    box-shadow: 0 0 6px rgba(0, 200, 83, 0.6);\n  }\n  50% {\n    box-shadow: 0 0 16px 6px rgba(0, 230, 118, 0.9);\n  }\n  100% {\n    box-shadow: 0 0 6px rgba(0, 200, 83, 0.6);\n  }\n}\n\n//catlog inside src\n.catalog-sticky-header {\n  position: sticky;\n  top: 60px;\n  z-index: 999;\n  background: #F0F5FA;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px;\n  margin: 0 -10px 20px -12px;\n  // border-bottom: 2px solid #F0F5FA;\n  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  \n  .catalog-header-left {\n    .mainTitle {\n      margin-bottom: 4px;\n      font-size: 28px;\n      font-weight: 600;\n      color: #1e293b;\n    }\n    \n    .subText {\n      font-size: 14px;\n      color: #64748b;\n      margin: 0;\n    }\n  }\n  \n  .catalog-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n}\n\n\n.cart-fab-inline {\n  position: relative;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #2563eb, #1e40af);\n  color: #fff;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);\n  transition: all 0.25s ease;\n  z-index: 1; /* ✅ Added - keeps button visible */\n  \n  &:hover {\n    transform: translateY(-3px) scale(1.08);\n    box-shadow: 0 10px 24px rgba(37, 99, 235, 0.5);\n  }\n  \n  &:active {\n    transform: translateY(-1px) scale(1.02);\n  }\n}\n\n/* Cart Badge */\n.cart-fab-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: #22c55e;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 7px;\n  border-radius: 999px;\n  min-width: 22px;\n  text-align: center;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);\n  line-height: 1.2;\n  border: 2px solid #F0F5FA;\n  z-index: 2; /* ✅ Added - keeps badge on top */\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .catalog-sticky-header {\n    padding: 12px 16px;\n    top: 60px; /* ✅ Keep consistent on mobile */\n    \n    .catalog-header-left {\n      .mainTitle {\n        font-size: 22px;\n      }\n    }\n    \n    .cart-fab-inline {\n      width: 46px;\n      height: 46px;\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .catalog-sticky-header {\n    .catalog-header-left {\n      .mainTitle {\n        font-size: 20px;\n      }\n      \n      .subText {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
